module.exports = __webpack_public_path__ + "static/media/food_category.9a4985db.jpg";